import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/editorial-team');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions(
  'editorialTeam',
  validationApi,
);

export function getEditorialTeamValidationHistoryOptions(editorialTeamId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(editorialTeamId);
}

export function getEditorialTeamValidationOptions(editorialTeamId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(editorialTeamId);
}

export function useValidateEditorialTeam(editorialTeamId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(editorialTeamId, queryClient));
}
